<template>
    <ScorecardResult :scorecard-id="scorecardId || undefined" :rule-id="ruleId || undefined" />
</template>
<script setup lang="ts">
import ScorecardResult from '@/components/contact/qa/ScorecardResult.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

definePage({
    name: 'scorecard-result',
    meta: {
        title: 'Scorecard Result',
        noPadding: true,
    },
});

const route = useRoute<'scorecard-result'>();

const scorecardId = computed(() => {
    if (!route.params.id) {
        return null;
    }
    const parsed = parseInt(route.params.id, 10);
    if (Number.isNaN(parsed)) {
        return null;
    }
    return parsed;
});
const ruleId = computed(() => {
    const q = route.query.ruleId as any;
    if (!q) return null;
    const parsed = parseInt(q, 10);
    return Number.isNaN(parsed) ? null : parsed;
});

</script>